import {
  Box,
  Button,
  ChartAreaIcon,
  ExpansionPanelProps,
  InfoCardList,
  SidebarExpansionPanel,
  useModal,
} from '@forgeglobal/design-framework'
import { CreateHoldingModal } from 'components/holdings/CreateHoldingModal'
import { transformHoldingFragment } from 'components/holdings/HoldingUtils'
import { useAccountHoldingsQuery, useBaseIssuerAccountQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

interface HoldingsSidebarPanelProps extends Omit<ExpansionPanelProps, 'children'> {
  issuerAccountId: string
}

const HoldingsSidebarPanel: React.FC<HoldingsSidebarPanelProps> = ({ issuerAccountId, ...props }) => {
  const { data } = useAccountHoldingsQuery({ variables: { accountId: issuerAccountId } })
  const holdings = data?.account?.holdings ?? []
  const issuerAccountData = useBaseIssuerAccountQuery({ variables: { issuerId: issuerAccountId } })
  const company = issuerAccountData?.data?.account?.issuer_account?.company
  const holdingIssuer = company
    ? {
        companyId: company.id,
        companyName: company.name,
      }
    : undefined
  const [openCreateHoldingModal, hideCreateHoldingModal] = useModal(() => {
    return <CreateHoldingModal hideModal={hideCreateHoldingModal} fromIssuer={holdingIssuer} />
  }, [holdingIssuer])
  const dataList = holdings.map(holding => transformHoldingFragment(holding, true))
  return (
    <SidebarExpansionPanel icon={<ChartAreaIcon />} title="Holdings" {...props}>
      <Button onClick={openCreateHoldingModal} fullWidth>
        Create Holding
      </Button>
      {!!dataList.length && (
        <Box mt={2}>
          <InfoCardList items={dataList} />
        </Box>
      )}
    </SidebarExpansionPanel>
  )
}

export { HoldingsSidebarPanel }
